import {ItemConfig, Price} from '../app3D/ItemConfig';

import * as _ from "lodash";

export class Basket{
	public content = {} as any;
	protected $: JQueryStatic;

	constructor(
		public container
	){
		this.$ = $;
	}

	// Add item to basket
	add(itemConfig:ItemConfig, cnt) {
		cnt = Number(cnt);
		if (this.content.hasOwnProperty(itemConfig.hash))
			this.content[itemConfig.hash].count += cnt;
		else
			this.content[itemConfig.hash] = {
				item: itemConfig,
				count: cnt
			};
		this.update();
		this.$('#order').addClass('open');
	};

	// Remove item from basket (all of them)
	remove(hash) {
		delete this.content[hash];
		this.update();
	};

// Update summary from basket content
	update(){
		let b = this;
		let t = this.$(b.container).find('tbody');
		let z = t.children('tr:last');
		t.children('tr').filter((i: number, e:Element):boolean => {
			let $e = this.$(e);
			if ($e.hasClass('total'))
				return;
			if (b.content.hasOwnProperty($e.attr('data-config-hash')))
				return;
			e.remove();
		});

		let priceTotal = 0;
		_.each(b.content, (art) => {
			let r = this.$('tr[data-config-hash="'+art.item.hash+'"]');
			let priceArt = art.item.price() * art.count;

			// create new row for non-existent config
			if (!r.length){
				// main row
				let label = art.item.label;
				let trPrd = this.$('<tr data-config-hash="'+art.item.hash+'"><th><label for="a:'+art.item.hash+'">'+art.item.getLabel()+'</label></th>' +
	'</tr>');
				let tdCnt = this.$('<td class="cnt"></td>');
				let ctCnt = this.$('<input class="cnt" type="number" name="a:'+art.item.hash+'" value="1" title="Počet kusů"/>');
				ctCnt.change(function () {
					let val = Number(b.$(this).val());
					if (val <= 0)
						b.remove(art.item.hash);
					else{
						b.content[art.item.hash].count = val;
						b.update();
					}
				});
				tdCnt.append(ctCnt);
				let tdPrc = this.$('<td class="price config-price">'+Price.print(art.item.price())+'</td>');
				let tdCtl = this.$('<td class="ctl"></td>');
				let btDel = this.$('<button type="button" class="remove" title="Odebrat položku"><span class="fa fa-trash"></span></button>');
				btDel.click(function () {
					b.remove(art.item.hash)
				});
				tdCtl.append(btDel);
				trPrd.append(tdCtl, tdCnt, tdPrc, tdCtl);

				// detail table/row
				let tdDet = this.$('<td colspan="3"></td>');
				tdDet.append(art.item.detailTable(this.$));
				tdDet.append('<input type="hidden" name="c:'+art.item.hash+'" value="'+art.item.configString+'"/>');
				let trDet = this.$('<tr data-config-hash="'+art.item.hash+'" class="detail"></tr>');
				trDet.append(tdDet);

				r = z.before(trPrd, trDet);
			}
			r.find('input.cnt').val(art.count);
			r.find('td.config-price').text(Price.print(priceArt));
			priceTotal += priceArt;
		});
		this.$('#order-price').text(Price.print(priceTotal));
	};
}



// WEBPACK FOOTER //
// ./src/script/app/Basket.ts